import request from './request'

export function listRepacking(data) {
  return request.post('/inventory/repackings/list', data)
}
export function getRepacking(id) {
  return request.get('/inventory/repackings/' + id)
}
export function saveRepacking(data) {
  return request.post('/inventory/repackings', data)
}
export function updateRepacking(data) {
  return request.post('/inventory/repackings/update', data)
}
export function deleteRepacking(ids) {
  return request.post('/inventory/repackings/delete', ids)
}
export function postRepacking(repackingId) {
  return request.post('/inventory/repackings/post', { repackingId })
}
